/**
 * Frontend init for offbeat/vendor-gallery-filmstrip.
 *
 * Finds every filmstrip wrapper on the page and initializes Flickity once
 * its images have loaded. Reads carousel settings from the wrapper's data
 * attributes. Flickity and imagesLoaded are expected to be globally available
 * via celebrate-core-features.
 */
function offbeatInitVendorFilmstrips() {
	if ( typeof Flickity === 'undefined' || typeof imagesLoaded === 'undefined' ) {
		return;
	}

	const wrappers = document.querySelectorAll( '.wp-block-offbeat-vendor-gallery-filmstrip' );

	wrappers.forEach( ( wrapper ) => {
		const gallery = wrapper.querySelector( '.celebrate-custom-field-slider' );
		if ( ! gallery || gallery.classList.contains( 'flickity-enabled' ) ) {
			return;
		}

		const navigation     = wrapper.getAttribute( 'data-navigation' ) === 'true';
		const pagination     = wrapper.getAttribute( 'data-pagination' ) === 'true';
		const autoplay       = wrapper.getAttribute( 'data-autoplay' ) === 'true';
		const autoplaySpeed  = parseInt( wrapper.getAttribute( 'data-autoplaySpeed' ), 10 ) || 4000;
		const groupCells     = wrapper.getAttribute( 'data-groupCells' ) === 'true';
		const centerMode     = wrapper.getAttribute( 'data-centerMode' ) === 'true';

		imagesLoaded( gallery, function() {
			new Flickity( gallery, {
				cellAlign: centerMode ? 'center' : 'left',
				draggable: true,
				wrapAround: true,
				autoPlay: autoplay ? autoplaySpeed : false,
				prevNextButtons: navigation,
				pageDots: pagination,
				groupCells: groupCells,
			} );

			gallery.style.opacity = '1';
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', offbeatInitVendorFilmstrips );
} else {
	offbeatInitVendorFilmstrips();
}
